import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { toast } from 'react-toastify';

const deleteGame = (id: number) => api.delete(`/game/${id}`);

export const useDeleteGameMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['delete-game'],
    mutationFn: deleteGame,
    onSuccess: () => {
      toast.success('Game deleted successfully');

      queryClient.invalidateQueries({
        queryKey: ['games'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
